/* Memento Matcha — Custom JS for Dawn */

/* Hero parallax (video or image) */
const heroBgEl = document.querySelector('.mm-video-hero__bg video') || document.querySelector('.mm-video-hero__bg img');
if (heroBgEl) {
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    heroBgEl.style.transform = `translateY(${y * 0.25}px)`;
  }, { passive: true });
}

/* Product page parallax */
const productImg = document.querySelector('.product__media img');
if (productImg) {
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        const rect = productImg.getBoundingClientRect();
        const viewH = window.innerHeight;
        const visible = (viewH - rect.top) / (viewH + rect.height);
        const clamped = Math.max(0, Math.min(visible, 1));
        const shift = (clamped - 0.4) * 60;
        productImg.style.transform = `translateY(${-shift}px) scale(${1 + clamped * 0.02})`;
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
}

/* Fade-up on scroll — resilient: content is visible by default,
   animation is a progressive enhancement only. Never leaves content hidden. */
const fadeEls = document.querySelectorAll('.fade-up');
if (fadeEls.length && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.style.opacity = '';
        e.target.style.animation = 'fadeUp 0.6s ease forwards';
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  fadeEls.forEach(el => {
    // Only hide if it's currently below the fold; visible-on-load stays visible
    const rect = el.getBoundingClientRect();
    if (rect.top > window.innerHeight) {
      el.style.opacity = '0';
    }
    observer.observe(el);
  });
}

/* Product-card secondary-media video:
   - Desktop (hover-capable): play on hover, revert to the can image on leave.
   - Touch / mobile (no hover): when the card scrolls into view, play the video ONCE,
     then fade back to the static can image. */
function initCardHoverVideos() {
  var isTouch = window.matchMedia('(hover: none)').matches || window.matchMedia('(max-width: 749px)').matches;
  // Mobile / touch: keep the product cards as the static can image only — no video.
  if (isTouch) return;
  var MM_VIDEO_START = 1; // seconds — skip the slow lead-in so the pour happens faster
  // Per-video start offset (data-mm-start). Hojicha has a slower lead-in, so its card
  // video starts a little later to match the matcha pour timing.
  function mmStart(v) {
    var s = parseFloat(v && v.dataset ? v.dataset.mmStart : '');
    return isNaN(s) ? MM_VIDEO_START : s;
  }
  var io = null;
  if (isTouch && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var video = e.target.querySelector('.mm-card-video');
        if (!video) return;
        if (e.isIntersecting) {
          if (video.dataset.played) return; // only play once per visit into view
          video.dataset.played = '1';
          video.classList.add('is-playing');
          try { video.currentTime = mmStart(video); } catch (err) {}
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          // fully out of view → reset so it can replay next time it's scrolled to
          video.classList.remove('is-playing');
          video.pause();
          delete video.dataset.played;
        }
      });
    }, { threshold: 0.3 });
  }
  document.querySelectorAll('.card-wrapper').forEach(function (wrap) {
    var video = wrap.querySelector('.mm-card-video');
    if (!video || video.dataset.hoverInit) return;
    video.dataset.hoverInit = '1';
    video.muted = true; // guarantee no sound + allow mobile autoplay
    // When the clip finishes, fade back to the static can image.
    video.addEventListener('ended', function () {
      video.classList.remove('is-playing');
    });
    // Skip the slow first second — also re-skips it each time the clip loops back to 0.
    video.addEventListener('timeupdate', function () {
      var s = mmStart(video);
      if (video.currentTime < s - 0.05) {
        try { video.currentTime = s; } catch (e) {}
      }
    });
    if (isTouch && io) {
      video.loop = false; // mobile: play once, then return to the can image
      // Cap playback to a short "taste" so the CAN stays the hero of the card.
      var MM_VIDEO_CAP = 7; // seconds
      video.addEventListener('timeupdate', function () {
        if (video.classList.contains('is-playing') && video.currentTime >= MM_VIDEO_CAP) {
          video.classList.remove('is-playing'); // fade back to the can image
          video.pause();
        }
      });
      io.observe(wrap);
    } else {
      wrap.addEventListener('mouseenter', function () {
        var s = mmStart(video);
        try { if (video.currentTime < s) video.currentTime = s; } catch (e) {}
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      });
      wrap.addEventListener('mouseleave', function () {
        video.pause();
        try { video.currentTime = mmStart(video); } catch (e) {}
      });
    }
  });
}
if (document.readyState !== 'loading') {
  initCardHoverVideos();
} else {
  document.addEventListener('DOMContentLoaded', initCardHoverVideos);
}

/* Product-page gallery: the hosted video is rendered natively (always in the DOM) by
   product-thumbnail.liquid. The browser autoplays it when it's on screen, but inside a
   horizontal swipe slider the browser doesn't always notice the slide becoming visible,
   so we nudge play()/pause() based on how much of the video is actually in the viewport.
   Listening to the slider's own scroll means swiping to the video starts it. */
function initPdpVideoAutoplay() {
  var vids = [].slice.call(document.querySelectorAll('.mm-pdp-video video'));
  if (!vids.length) return;

  vids.forEach(function (v) {
    v.muted = true;
    v.setAttribute('muted', '');
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    // Tap to pause / resume (we removed the zoom overlay for videos).
    if (!v.dataset.mmTap) {
      v.dataset.mmTap = '1';
      v.style.cursor = 'pointer';
      v.addEventListener('click', function () {
        if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }
  });

  function visibleFraction(el) {
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return 0;
    var w = Math.max(0, Math.min(r.right, window.innerWidth) - Math.max(r.left, 0));
    var h = Math.max(0, Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0));
    return (w * h) / (r.width * r.height);
  }

  function update() {
    vids.forEach(function (v) {
      if (visibleFraction(v) >= 0.55) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }

  var t;
  function deb() { clearTimeout(t); t = setTimeout(update, 90); }
  window.addEventListener('scroll', deb, { passive: true });
  window.addEventListener('resize', deb, { passive: true });

  // Also listen to each video's horizontal slider so a swipe starts it.
  var seen = [];
  vids.forEach(function (v) {
    var p = v.parentElement;
    while (p) {
      var ox = getComputedStyle(p).overflowX;
      if (ox === 'auto' || ox === 'scroll') {
        if (seen.indexOf(p) === -1) { seen.push(p); p.addEventListener('scroll', deb, { passive: true }); }
        break;
      }
      p = p.parentElement;
    }
  });

  update();
  setTimeout(update, 500); // re-check after the slider has laid out
}
if (document.readyState !== 'loading') {
  initPdpVideoAutoplay();
} else {
  document.addEventListener('DOMContentLoaded', initPdpVideoAutoplay);
}
